module.exports = __webpack_public_path__ + "static/media/weekly-report-icon.0b37b098.svg";